var _rect, _rect2, _path, _use, _use2, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagOfTaiwanRepublicOfChina(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 600,
    viewBox: "-60 -40 240 160",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -60,
    y: -40,
    width: "100%",
    height: "100%",
    fill: "#fe0000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -60,
    y: -40,
    width: "50%",
    height: "50%",
    fill: "#000095"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "four_rays",
    d: "M 8,0 L 0,30 L -8,0 L 0,-30 M 0,8 L 30,0 L 0,-8 L -30,0",
    fill: "#fff"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#four_rays",
    transform: "rotate(30)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#four_rays",
    transform: "rotate(60)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 17,
    fill: "#000095"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 15,
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagOfTaiwanRepublicOfChina);
export default __webpack_public_path__ + "static/media/Flag_of_Taiwan_Republic_of_China.e42403dc9eab832f42f923885bd16f34.svg";
export { ForwardRef as ReactComponent };